import './css/style.css'
import './css/satoshi.css'
import 'jsvectormap/dist/jsvectormap.css'
import 'flatpickr/dist/flatpickr.min.css'
import 'react-toastify/dist/ReactToastify.css'

import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import App from './App'
import { AuthProvider } from './context/auth'

const queryClient = new QueryClient()

const VITE_SENTRY_DSN = import.meta.env.PROD ? import.meta.env.VITE_SENTRY_DSN : ''
Sentry.init({
  dsn: VITE_SENTRY_DSN,
  tracesSampleRate: 1.0
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
        <ToastContainer />
      </AuthProvider>
    </Router>
  </React.StrictMode>
)
